import React from 'react';
import { Card } from '@app/screens/rewards/components/Card';
import { Box, Button } from '@chakra-ui/react';
import { PendingRewardRow } from '@app/screens/rewards/components/PendingRewardRow';

import s from './PendingRewardWidget.module.scss';
import { usePendingRewardsDetails } from '@app/hooks/ryo/usePendingRewardsDetails';
import { showErrorToast, showSuccessToast } from '@app/components/Toast';
import { ExternalLink } from '@app/components/ExternalLink';
import { TransactionError } from '@thirdweb-dev/react';

export const PendingRewardsWidget = () => {
  const { distributedTokensIndexes, hasItemsToClaim, claimAll } =
    usePendingRewardsDetails();

  return (
    <Card
      title="Pending Rewards"
      titleAction={
        <Button
          variant="row"
          isDisabled={!hasItemsToClaim}
          onClick={async () => {
            try {
              const res = await claimAll();

              const txHash = res?.receipt?.transactionHash;

              if (txHash) {
                showSuccessToast(
                  `Successfully claimed rewards`,
                  <ExternalLink txHash={txHash} />
                );
              }
            } catch (e) {
              if (e instanceof TransactionError) {
                showErrorToast(e.reason);
              } else {
                showErrorToast(`Error claiming rewards`);
              }
            }
          }}
        >
          Claim All
        </Button>
      }
    >
      <Box
        sx={{
          maxHeight: ['unset', '240px'],
          overflow: 'auto',
          paddingRight: ['8px', '24px']
        }}
        className={s.scrollable}
      >
        {distributedTokensIndexes.map(item => {
          return <PendingRewardRow key={item} index={item} />;
        })}
      </Box>
    </Card>
  );
};
